function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 4C23 6.20914 24.7909 8 27 8C28.0609 8 29.0783 7.57857 29.8284 6.82843C30.5786 6.07828 31 5.06087 31 4C31 1.79086 29.2091 0 27 0C24.7909 0 23 1.79086 23 4ZM25 4C25 2.89543 25.8954 2 27 2C27.5304 2 28.0391 2.21071 28.4142 2.58579C28.7893 2.96086 29 3.46957 29 4C29 5.10457 28.1046 6 27 6C25.8954 6 25 5.10457 25 4Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1 30H25.9C24.8732 30.0058 24.0088 29.233 23.9 28.212L23.38 24.126C23.332 23.7701 23.4785 23.4158 23.7638 23.1978C24.0491 22.9797 24.4295 22.9314 24.7603 23.0712C25.091 23.211 25.3215 23.5174 25.364 23.874L25.884 27.974L28.084 28L29 20.872C29.0647 20.3702 29.494 19.9958 30 20H30.896L30.096 12H25C24.4477 12 24 11.5523 24 11C24 10.4477 24.4477 10 25 10H30.1C31.1268 9.99422 31.9911 10.767 32.1 11.788L33 20.902C33.0277 21.1837 32.9347 21.464 32.7441 21.6734C32.5535 21.8827 32.2831 22.0014 32 22H30.878L30.09 28.226C29.9749 29.2377 29.1182 30.0014 28.1 30Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 4C3 6.20914 4.79086 8 7 8C8.06087 8 9.07828 7.57857 9.82843 6.82843C10.5786 6.07828 11 5.06087 11 4C11 1.79086 9.20914 0 7 0C4.79086 0 3 1.79086 3 4ZM5 4C5 2.89543 5.89543 2 7 2C7.53043 2 8.03914 2.21071 8.41421 2.58579C8.78929 2.96086 9 3.46957 9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.10006 30H5.90006C4.87325 30.0058 4.00889 29.233 3.90006 28.212L3.12206 22H2.00006C1.71696 22.0014 1.44654 21.8827 1.25591 21.6734C1.06529 21.464 0.97231 21.1837 1.00006 20.902L1.90606 11.8C2.01534 10.7774 2.87759 10.0013 3.90606 10H9.00006C9.55234 10 10.0001 10.4477 10.0001 11C10.0001 11.5523 9.55234 12 9.00006 12H3.90006L3.10006 20H4.00006C4.50599 19.9958 4.93531 20.3702 5.00006 20.872L5.90206 27.974L8.10006 28L8.62806 23.874C8.67055 23.5174 8.90098 23.211 9.23176 23.0712C9.56255 22.9314 9.94289 22.9797 10.2282 23.1978C10.5136 23.4158 10.6601 23.7701 10.6121 24.126L10.0921 28.226C9.97692 29.2384 9.11902 30.0025 8.10006 30Z",
  fill: "#32D882"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 4C13 6.20914 14.7909 8 17 8C18.0609 8 19.0783 7.57857 19.8284 6.82843C20.5786 6.07828 21 5.06087 21 4C21 1.79086 19.2091 0 17 0C14.7909 0 13 1.79086 13 4ZM15 4C15 2.89543 15.8954 2 17 2C17.5304 2 18.0391 2.21071 18.4142 2.58579C18.7893 2.96086 19 3.46957 19 4C19 5.10457 18.1046 6 17 6C15.8954 6 15 5.10457 15 4Z",
  fill: "#32D882"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.906 32H18.094C19.1219 32.001 19.9832 31.2227 20.086 30.2L20.906 22H22C22.2835 22.0014 22.5543 21.8825 22.745 21.6727C22.9357 21.4629 23.0284 21.1821 23 20.9L22.094 11.8C21.9909 10.7742 21.125 9.99483 20.094 10H13.916C12.8851 9.99483 12.0191 10.7742 11.916 11.8L11 20.9C10.9717 21.1821 11.0644 21.4629 11.2551 21.6727C11.4458 21.8825 11.7165 22.0014 12 22H13.094L13.906 30.2C14.0091 31.2258 14.8751 32.0052 15.906 32ZM14 20H13.106L13.906 12H20.094L20.894 20H20C19.4845 19.9974 19.0516 20.3871 19 20.9L18.094 30H15.906L15 20.9C14.9485 20.3871 14.5155 19.9974 14 20Z",
  fill: "#32D882"
});

var SvgVenueManagment1 = function SvgVenueManagment1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment1.3a33a923.svg";
export { ForwardRef as ReactComponent };